import { reactive } from 'vue'

export type ToastVariant = 'success' | 'info' | 'warning' | 'error'

export interface ToastItem {
  id: number
  message: string
  variant: ToastVariant
}

const AUTO_DISMISS_MS = 8000

const state = reactive({
  items: [] as ToastItem[],
})

const timers = new Map<number, number>()
let seq = 0

function clearTimer(id: number) {
  const timer = timers.get(id)
  if (timer != null) {
    window.clearTimeout(timer)
    timers.delete(id)
  }
}

function dismiss(id: number) {
  clearTimer(id)
  state.items = state.items.filter((item) => item.id !== id)
}

function push(message: string, variant: ToastVariant) {
  const text = message.trim()
  if (!text) return
  const id = ++seq
  state.items.push({ id, message: text, variant })
  timers.set(
    id,
    window.setTimeout(() => dismiss(id), AUTO_DISMISS_MS),
  )
}

export const toast = {
  get items() {
    return state.items
  },
  dismiss,
  success(message: string) {
    push(message, 'success')
  },
  info(message: string) {
    push(message, 'info')
  },
  warning(message: string) {
    push(message, 'warning')
  },
  error(message: string) {
    push(message, 'error')
  },
}
